// Reducers for
// store/action-methods/global.js
export const reducer = {}
